import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "We launched our new café with Tactiq bottles on every table. Customers literally took our brand home. Best marketing dollars we've spent — by a wide margin.",
    name: "Sara Khan",
    role: "Founder",
    company: "Maison Bramalea",
  },
  {
    quote:
      "Closed five listings with our branded Tactiq bottles as welcome gifts. Clients keep them on their counters for months. It's a constant reminder.",
    name: "Daniel Lopes",
    role: "Realtor",
    company: "Royal Heights Realty",
  },
  {
    quote:
      "The QR analytics dashboard alone was worth it. We saw exactly which event drove the most scans, by city. We never had that data before.",
    name: "Priya Sharma",
    role: "Marketing Director",
    company: "FitNorth Studios",
  },
  {
    quote:
      "From mockup to delivery in 12 days. Two skids, no fuss, beautifully printed. Our team grabs one every morning — it became part of our culture.",
    name: "Marc Tremblay",
    role: "Head of People",
    company: "Northstar Tech",
  },
];

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  const t = TESTIMONIALS[i];

  return (
    <section
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-white border-y border-slate-100"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <div className="overline">Clients · Toronto + GTA</div>
          <div className="flex items-center gap-3">
            <button
              data-testid="testimonial-prev"
              onClick={prev}
              className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-900 hover:text-white transition-colors"
              aria-label="Previous testimonial"
            >
              <ChevronLeft size={18} />
            </button>
            <span className="font-mono text-sm text-slate-500">
              {String(i + 1).padStart(2, "0")} / {String(TESTIMONIALS.length).padStart(2, "0")}
            </span>
            <button
              data-testid="testimonial-next"
              onClick={next}
              className="w-12 h-12 rounded-full border border-slate-200 flex items-center justify-center hover:bg-slate-900 hover:text-white transition-colors"
              aria-label="Next testimonial"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div data-testid={`testimonial-${i}`} className="relative">
          <blockquote className="relative font-editorial text-3xl sm:text-5xl leading-[1.2] tracking-tight text-slate-900 italic max-w-5xl">
            <span className="font-editorial text-4xl sm:text-5xl align-top mr-1 text-[var(--tq-navy)]/50">&ldquo;</span>
            {t.quote}
            <span className="font-editorial text-4xl sm:text-5xl align-bottom ml-1 text-[var(--tq-navy)]/50">&rdquo;</span>
          </blockquote>
          <div className="mt-10 flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-[var(--tq-navy)] text-white flex items-center justify-center font-display font-black text-lg">
              {t.name
                .split(" ")
                .map((p) => p[0])
                .join("")
                .slice(0, 2)}
            </div>
            <div>
              <div className="font-display font-bold text-lg">{t.name}</div>
              <div className="text-sm text-slate-600">
                {t.role} · {t.company}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
